import { Observable } from 'rxjs';
import { DetailsInterface } from '../models/details.model';
import { DetailsRepository } from '../repositories/details.repository';
import { UseCase } from '@/core/base/use-case';

export interface ReservationDetailsRequest {
    reservationCode: string;
    lastName: string;
}

export class getDetailsUseCase
    implements UseCase<ReservationDetailsRequest, DetailsInterface>
{
    constructor(private readonly repository: DetailsRepository) {}

    execute(
        reservationDetails: ReservationDetailsRequest,
    ): Observable<DetailsInterface> {
        return this.repository.getDetails(reservationDetails);
    }
}
